import { render, staticRenderFns } from "./page-header.vue?vue&type=template&id=0dcae7b3&scoped=true"
import script from "./page-header.vue?vue&type=script&lang=js"
export * from "./page-header.vue?vue&type=script&lang=js"
import style0 from "./page-header.vue?vue&type=style&index=0&id=0dcae7b3&prod&lang=scss&scoped=true"
import style1 from "./page-header.vue?vue&type=style&index=1&id=0dcae7b3&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0dcae7b3",
  null
  
)

export default component.exports